import React from 'react';
import Carousel from './Carousel';
import TrendingDestinations from '../pages/TrendingDestinations';
import AboutSection from '../pages/AboutSection';
import BrandSection from '../pages/BrandSection';
import TourSection from '../pages/TourSection';
import TourDiscover from '../pages/TourDiscover';
import MarqueeSection from '../pages/MarqueeSection';
import TopDestination from '../pages/TopDestination';
import TestimonialSection from '../pages/TestimonialSection';
import NewsSection from '../pages/NewsSection';




const HeroSection = () => {
  
  return (

    <div className="th-hero-wrapper hero-1" id="hero">
<Carousel/>
{/* <TrendingDestinations/> */}
<AboutSection/>
{/* <BrandSection/> */}
<TourSection/>
<TourDiscover/>
{/* <MarqueeSection/> */}
<TopDestination/>
<TestimonialSection/>
<NewsSection/>

    </div>
  );
};

export default HeroSection;
